const $ = require('jquery')

const { BREAKPOINT } = require('./api')

// =========================================================================
// Module: info section
// =========================================================================
const infoSection = {
  init () {
    const _ = $('#info-section__main')
    let target
    let clone
    const indicators = $('.info-section__slider .carousel-indicators li')

    if (_.hasClass('item') && window.innerWidth > BREAKPOINT.TABLET) {
      target = $('.info-section__grid > .row')

      const classes = _.attr('data-class')
      _.attr('class', classes)
      _.removeAttr('data-class')

      clone = _.clone()
      _.remove()
      clone.prependTo(target)

      $('.info-section__slider .item:first').addClass('active')
      indicators.first().addClass('active')

      indicators.last().remove()
    } else if (!_.hasClass('item') && window.innerWidth <= BREAKPOINT.TABLET) {
      target = $('.info-section__slider .carousel-inner')

      const classes = _.attr('class')
      _.attr('data-class', classes)
      _.removeAttr('class')

      _.appendTo(target)
      _.addClass('item')

      target.next('.carousel-indicators').append(`<li data-target="#info-section-carousel" data-slide-to="${_.index()}" class="info-sect-main"></li>`)

      const $carousel = $('#info-section-carousel')

      if ($carousel.exists()) {
        try {
          const hammerCarousel = new Hammer($carousel.get(0))

          hammerCarousel
            .on('swiperight', function() {
              $carousel.carousel('prev')
            })
            .on('swipeleft', function() {
              $carousel.carousel('next')
            })
        } catch (err) {
          log.error('error Hammer', err)
        }

      }
    }
  },
}

module.exports = infoSection




// WEBPACK FOOTER //
// ./src/modules/infoSection.js